var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"transkribusEditor"}},[(_vm.xmlJsonString)?_c('Editor',{attrs:{"iiifUrl":_vm.iiifUrl,"xmlJson":_vm.toJsonObject}}):_c('Editor',{attrs:{"iiifUrl":_vm.iiifUrl,"xmlJson":_vm.xmlJson}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }